import { Injectable } from '@angular/core';
import { LoginService } from './login/login.service';

@Injectable({
  providedIn: 'root'
})

export class AppMenuService {

	private Jsn:any ;

	constructor(private loginService: LoginService){}

	getAppMenus() {
		const profile:string=this.loginService.getVariableSesion("profile");
		return this.getMenu(profile);
	}

	getMenu(profile:string)
	{
		// profile = 'Compras'
		switch (profile) {
			case "Administrador":{
				this.Jsn = [
					{
						'icon': 'fa fa-home',
						'title': 'Inicio',
						'url': '/home'
					},
					{
						'icon': 'fa fa-magnifying-glass',
						'title': 'Consulta de PP',
						'url': '/pp/consulta'
					},
					{
						'icon': 'fa fa-pen-to-square',
						'title': 'PP En Trámite',
						'url': '/pp/en-tramite'
					},
					
				]
				break;
			}

			case "Gerente":{
				this.Jsn = [
					{
						'icon': 'fa fa-home',
						'title': 'Inicio',
						'url': '/home'
					},
					{
						'icon': 'fa fa-magnifying-glass',
						'title': 'Consulta de PP',
						'url': '/pp/consulta'
					},
					{
						'icon': 'fa fa-pen-to-square',
						'title': 'PP En Trámite',
						'url': '/pp/en-tramite'
					},
					
				]
				break;
			}

			case "Promotor":{
				this.Jsn = [
					{
						'icon': 'fa fa-home',
						'title': 'Inicio',
						'url': '/home'
					},
					{
						'icon': 'fa fa-magnifying-glass',
						'title': 'Consulta de PP',
						'url': '/pp/consulta'
					},
					{
						'icon': 'fa fa-pen-to-square',
						'title': 'PP En Trámite',
						'url': '/pp/en-tramite'
					},
					
				]
				break;
			}

			case "Asesor Comercial":{
				this.Jsn = [
					{
						'icon': 'fa fa-home',
						'title': 'Inicio',
						'url': '/home'
					},
					{
						'icon': 'fa fa-magnifying-glass',
						'title': 'Consulta de PP',
						'url': '/pp/consulta'
					},
					{
						'icon': 'fa fa-pen-to-square',
						'title': 'PP En Trámite',
						'url': '/pp/en-tramite'
					},
					
				]
				break;
			}

			default: {
				this.Jsn = []
				break;
			}
		}

		return this.Jsn;
		
	}
}